<!-- <button (click)="changeBackround('white')">white</button> -->
<!-- <span style="background-color: gray; cursor: pointer;" (click)="changeBackround('gray')">
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span> &nbsp;
<span style="background-color: white;cursor: pointer;" (click)="changeBackround('white')">
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span> &nbsp;
<span style="background-color: black; cursor: pointer;" (click)="changeBackround('black')">
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span>  &nbsp; -->

<div>
    <div>
        <div id="overlay" *ngIf="!loadAsset">

            <div (mouseover)="enableThumbnail=true;setCss()" *ngIf="uploadURL.length > 1">

                <gallery id="ValPreview" [items]="images" fluid [nav]="false" [loadingStrategy]="lazy"
                    [imageSize]="cover" [thumb]="enableThumbnail" [counter]="enableThumbnail"
                    [itemTemplate]="itemTemplate" [thumbTemplate]="thumbTemplate" [thumbWidth]="90" [thumbHeight]="100">
                </gallery>

                <ng-container *ngTemplateOutlet="threeDtemplate"></ng-container>

                <a class="prev" *ngIf="enableThumbnail" (click)="previousImg()">
                    <sh-text class="sh-text-font"> &#10094; </sh-text>
                </a>
                <a class="next" *ngIf="enableThumbnail" (click)="nextImg()">
                    <sh-text class="sh-text-font"> &#10095; </sh-text>
                </a>
            </div>

            <div class="loader" *ngIf="uploadURL.length <= 1"
                [ngStyle]="{'background-color': previewBackgroudColor, 'text-align': 'center', 'position': 'relative'}">

                <img class="snapshot" alt="snapshot" *ngIf="uploadURL[0]" [src]="uploadURL[0]" />

                <ng-container *ngTemplateOutlet="threeDtemplate"></ng-container>
            </div>

        </div>

        <ng-template #threeDtemplate>
            <sh-icon slot="functions"
                *ngIf="supportedFiles.indexOf(filePath.split('.')[filePath.split('.').length -1].toLocaleLowerCase()) <= -1"
                button icon="error" id="unsuportedfile" class="threed-func-icon">
            </sh-icon>
            <sh-tooltip
                *ngIf="supportedFiles.indexOf(filePath.split('.')[filePath.split('.').length -1].toLocaleLowerCase()) <= -1"
                label="File format not supported for Preview" target="unsuportedfile" placement="bottom-right"
                variation="short">
            </sh-tooltip>
            <sh-icon slot="functions" size='l'
                *ngIf="supportedFiles.indexOf(filePath.split('.')[filePath.split('.').length -1].toLocaleLowerCase()) > -1"
                button icon="play" id="renderAsset" (click)="loadAsset = true" class="threed-func-icon">
            </sh-icon>
            <sh-tooltip
                *ngIf="supportedFiles.indexOf(filePath.split('.')[filePath.split('.').length -1].toLocaleLowerCase()) > -1"
                label="Start Preview" target="renderAsset" placement="right" variation="short">
            </sh-tooltip>
        </ng-template>

        <div *ngIf="loadAsset && supportedFiles.indexOf(filePath.split('.')[filePath.split('.').length -1].toLocaleLowerCase()) > -1"
            class="threed-preview">
            <app-three-asset-render [filePath]="filePath" [seenBackGround]="previewBackgroudColor" #threeViewer
                [width]="width" [height]="height" (polygonCount)="getPolygonCount($event)"
                (loadAsset)="getLoadAssetValue($event)">
            </app-three-asset-render>
        </div>

        <ng-template #thumbTemplate let-index="index" let-type="type" let-data="data" let-currIndex="currIndex">
            <img class="img-thumbnail" [src]="data.thumb">
        </ng-template>

        <ng-template #itemTemplate let-type="type" let-data="data" let-currIndex="currIndex">
            <video *ngIf="type === 'undefined'" [src]="data.src"></video>    
            <img id="slideImg" [src]="data.src">
        </ng-template>
    </div>
    <!-- <br> -->
    <!-- <sh-grid *ngIf="attributes" id="attributes">
        <div columns="9">
            <sh-grid *ngFor="let key of objectKeys(attributes)" id="attributes-value">
                <div columns="7">
                    <sh-text id="key" style="font:var(--body-1); margin-block-start: 4px;">{{ camelcaseToWord(key) }}
                    </sh-text>
                </div>
                <div columns="5">
                    <sh-text id="value"
                        *ngIf="key === 'creationDate' || key === 'lastUpdated' || key === 'maintainedUntil';else product"
                        style="font:var(--body-1);">{{attributes[key] | date}}</sh-text>
                    <ng-template #product>
                        <span *ngIf="key === 'productStatus'; else primary">
                           
                            <svg height="16" width="16" *ngIf="attributes[key] === 0">
                                <circle cx="10" cy="10" r="6" fill="#efdd59" />
                            </svg>
                            <svg height="16" width="16" *ngIf="attributes[key] === 1">
                                <circle cx="10" cy="10" r="6" fill="#57EE1E" />
                            </svg>
                            <sh-text style="font:var(--body-1);margin-inline-start: 28px;margin-block-start:-20px;">
                                {{attributes[key] | productStatus}}</sh-text>
                        </span>
                        <ng-template #primary>
                            <span *ngIf="key === 'primaryContact'; else normal"> {{attributes[key]?.name}}</span>
                            <ng-template #normal> {{attributes[key]}} </ng-template>
                        </ng-template>

                    </ng-template>
                </div>
            </sh-grid>
        </div>
        <div columns="2">
            <sh-button color='secondary' label='Contact' id="contactBtn"
                href="mailto:{{attributes.primaryContact.emailId}}">
            </sh-button>
        </div>
        <div columns="12" class="tags" id="tags">
            <span style="display: inline" *ngFor="let tag of tags">
                {{ tag }}
            </span>
        </div>
    </sh-grid> -->
</div>